import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

let httpHeaders = new HttpHeaders()
  .set('Authorization', 'Bearer ' + localStorage.getItem('token'))
  .set('Content-Type', 'application/json');
let options = {
  headers: httpHeaders,
};

const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    'Content-Type': 'application/json',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class _userServicesService {
  private baseUrl = environment.apiUrl + 'User/';
  constructor(private http: HttpClient) {}

  GetUserList(Devid: any): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + 'GetUserList/' + Devid, {
      headers: httpHeaders,
      observe: 'response',
    });
  }
  GetAllUserList(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + 'GetUserList', {
      headers: httpHeaders,
      observe: 'response',
    });
  }

  GetLastUserIndex(DeviceID): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(
      this.baseUrl + 'GetLastUserIndex?mDevID=' + DeviceID,
      httpOptions
    );
  }
  AddUser(model: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'AddUser', model, {
      headers: httpHeaders,
      observe: 'response',
    });
  }
  EditUser(model: any): Observable<HttpResponse<any>> {
    console.log(model);
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'EditUser', model, {
      headers: httpHeaders,
      observe: 'response',
    });
  }

  DeleteUser(UserID: any, DevID: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      this.baseUrl + 'DeleteUser?UserID=' + UserID + '&devID=' + DevID,
      null,
      {
        headers: httpHeaders,
        observe: 'response',
      }
    );
  }

  DeleteUserFromDB(UserID: any, DevID: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      this.baseUrl + 'DeleteUserFromDB?UserID=' + UserID + '&devID=' + DevID,
      null,
      {
        headers: httpHeaders,
        observe: 'response',
      }
    );
  }

  // DeleteSelectedUser(UserList: any): Observable<HttpResponse<any>> {
  //   return this.http.post<HttpResponse<any>>(this.baseUrl + 'DeleteAllUser' , UserList ,null, {
  //     headers: httpHeaders,
  //     observe: 'response'
  //   }
  //   );
  // }

  DeleteSelectedUser(model: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(
      this.baseUrl + 'DeleteAllUser',
      model,
      httpOptions
    );

    // return this.http.post(this.baseUrl + 'DeleteUser',model,null, {
    //   headers: httpHeaders,
    //   observe: 'response'
    // }
    // );
  }

  postFile(fileToUpload: File): any {
    var formData = new FormData();
    formData.append('formdata', fileToUpload);
    //formData.append('formdata', fileToUpload);

    $.ajax({
      url: environment.apiUrl + 'User/' + 'SaveExcelData',
      data: formData,
      processData: false,
      contentType: false,
      type: 'POST',
      success: function (data) {
        return data;
      },
    });
  }
}
